export function setPageTitle(title: string) {
  document.title = `Moveris - ${title}`;
}
